import * as React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import Select, { ValueType } from 'react-select';
import { Button, DropdownItem } from 'reactstrap';
import { Dispatch } from 'redux';
import { applicationOptions } from '../../../stores/applications/selectors';
import { hasPrivilege } from '../../../stores/auth/selectors';
import { RootState } from '../../../stores/store';
import { selected } from '../../../stores/tables/selectors';
import { createUserApplicationKey, resetUserApplicationKey } from '../../../stores/users/actionCreators';
import ConfirmModal from '../../common/modals/ConfirmModal';
import MultiSelect from '../../common/MultiSelect';
import { copySingleApplication } from '../../../stores/applications/actionCreators';

interface Props extends LocalizeContextProps {
    hasPrivilege: (privileges: string[]) => boolean;
    applications: Array<{ label: string, value: string }>;
    selected: string[];
    applicationKey: {
        key: string;
        users: string[];
        application: string;
    };
    resetUsersApplicationKey: () => void;
    createUsersApplicationKey: (usersIds: string[], applicationId: string) => void;
    // assignUsersApplications: (usersIds: string[], applicationIds: string[]) => void;
}
interface State {
    showModal: boolean;
    selection?: ValueType<{ label: string, value: string }> | null;
    selectionId: ValueType<{ label: string, value: string }> | null;
}

class CreateUsersApplicationKeyAction extends React.Component<Props, State> {
    public constructor(props: Props) {
        super(props);
        this.state = {
            selection: [],
            selectionId: null,
            showModal: false,
        };
    }

    ignoreCancel: boolean = false;

    public render() {
        const t = this.props.translate;
        if (this.props.hasPrivilege(['SUPER_ADMIN','ADMIN'])) {
            return (
                <React.Fragment>
                    <DropdownItem
                        className="no-icon"
                        onClick={() => {
                            this.setState({ showModal: true });
                        }}
                    >
                        {t('users.button.createApplicationKey')}
                    </DropdownItem>
                    <ConfirmModal
                        className="overflow-visible"
                        header={this.props.applicationKey.key === '' ?
                            t('users.modal.createApplicationKey.header') as string : ''}
                        confirmText={t('modal.assign') as string}
                        isOpen={this.state.showModal}
                        confirm={this.assign}
                        cancel={this.cancel}
                    >
                        {this.props.applicationKey.key === '' ?
                        <div>
                        <p>{t('users.modal.createApplicationKey.text') as string}</p>
                        <Select className={"dropdown-select applicationKey-select"}
                            isMulti={false}
                            options={this.props.applications}
                            value={this.state.selection}
                            onChange={this.handleSelectChange}
                        />
                        </div>
                        :
                        <div>
                            <div>Generated Key: {this.props.applicationKey.key}</div>
                            <div>Application Id: {this.props.applicationKey.application}</div>
                            <div>User Ids: </div>
                            {this.props.applicationKey.users.map((user) => {
                                return (
                                    <div>{user}</div>
                                );
                            })}
                        </div>
                        }
                    </ConfirmModal>
                </React.Fragment>
            );
        } else {
            return null;
        }
    }

    private handleSelectChange = (val?: ValueType<{ label: string, value: string }>) => {
        var test = new Array(1);
        test[0] = (val === null || val === undefined) ? [] : val;
        this.setState({ selection: (val === null || val === undefined) ? [] : val, selectionId: val === null || val === undefined ? null : test });
    }

    private assign = () => {
        // Ignore the first time AAS is trying to close the modal
        // after generating a key
        this.ignoreCancel = true;
        if (this.state.selectionId && Array.isArray(this.state.selectionId) && this.state.selectionId.length > 0) {
        this.props.createUsersApplicationKey(
                this.props.selected,
                this.state.selectionId[0].value
            );
        }
    }

    private cancel = () => {
        // Ignore the first time AAS is trying to close the modal
        // after generating a key
        if (this.ignoreCancel) {
            this.ignoreCancel = false;  
        } else {
            this.setState({ showModal: false });
            this.props.resetUsersApplicationKey()
        };
    }
}

const mapStateToProps = (state: RootState) => ({
    applications: applicationOptions(state),
    hasPrivilege: hasPrivilege(state),
    selected: selected(state, 'users'),
    applicationKey: state.users.applicationKey,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    createUsersApplicationKey: (ids: string[], applicationId: string) =>
        dispatch(createUserApplicationKey(ids, applicationId)),
    resetUsersApplicationKey: () =>
        dispatch(resetUserApplicationKey()),
});

export default connect(mapStateToProps, mapDispatchToProps)(withLocalize(CreateUsersApplicationKeyAction));